import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FeatureEligibility } from 'pco-product-service-internal-consumer';
import { CustomError } from 'types';

export enum Features {
  ADD_PRODUCTS = 'ADD_PRODUCTS',
  BULK_CLOSURE = 'BULK_CLOSURE',
  VIEW_MANDATE_PROPOSAL = 'VIEW_MANDATE_PROPOSAL',
  CREATE_MANDATE_PROPOSAL = 'CREATE_MANDATE_PROPOSAL',
  DISTRIBUTE = 'DISTRIBUTE',
  DMA = 'DMA',
  VIDEO_IDENTIFICATION = 'VIDEO_IDENTIFICATION',
  MEMBERZONE = 'MEMBERZONE',
  DISCRETIONARY_MANDATE = 'DISCRETIONARY_MANDATE',
  MANAGE_SUBSCRIPTIONS = 'MANAGE_SUBSCRIPTIONS',
  CLIENT_PRICING_PORTAL = 'CLIENT_PRICING_PORTAL',
  EAM_EFA_DASHBOARD = 'EAM_EFA_DASHBOARD',
}

export type PartnerStatus = {
  isLoading: boolean;
  customError?: CustomError;
  partnerId: string | undefined;
  hasMemberCode: boolean;
  eligibility: FeatureEligibility[];
};

export const initialPartnerStatusState: PartnerStatus = {
  isLoading: true,
  customError: undefined,
  hasMemberCode: false,
  partnerId: '',
  eligibility: [],
};

const partnerStatusSlice = createSlice({
  name: 'PARTNER_STATUS',
  initialState: initialPartnerStatusState,
  reducers: {
    setPartnerId: (state, action: PayloadAction<string | undefined>) => {
      return { ...state, partnerId: action.payload };
    },
    setHasMemberCode: (state, action: PayloadAction<boolean>) => {
      return { ...state, hasMemberCode: action.payload };
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      return { ...state, isLoading: action.payload };
    },
    setIsEligible: (state, action: PayloadAction<FeatureEligibility[]>) => {
      return { ...state, eligibility: action.payload };
    },
  },
});

export const { setPartnerId, setHasMemberCode, setIsLoading, setIsEligible } = partnerStatusSlice.actions;
export default partnerStatusSlice.reducer;
